import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
import { DatePipe, formatDate } from '@angular/common';
import { Component,OnInit,ViewChild,ViewChildren} from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { IonVirtualScroll,IonContent,ModalController,ToastController,PopoverController, Platform} from '@ionic/angular';
import { AddCall } from 'src/providers/addvCall';
import { CommonService } from 'src/providers/common';
import { ServicesProvider } from 'src/providers/services';
import { AdvertisementPage } from '../advertisement/advertisement.page';
import { DatePikerPage } from '../date-piker/date-piker.page';
import { ModpricetagPage } from '../modpricetag/modpricetag.page';
import { RatingSortpagePage } from '../rating-sortpage/rating-sortpage.page';
import { Geolocation } from '@ionic-native/geolocation/ngx';
import { MediaElementPlayer } from 'mediaelement';
import { SuccessPage } from '../success/success.page';

@Component({
  selector: 'app-physio-doctors-list',
  templateUrl: './physio-doctors-list.page.html',
  styleUrls: ['./physio-doctors-list.page.scss'],
})
export class PhysioDoctorsListPage implements OnInit {
  @ViewChild(IonContent, { static: false }) content: IonContent;
  @ViewChildren('newVdo') vdoPlayer: MediaElementPlayer;
  currentPlaying = null;
  @ViewChild(IonVirtualScroll) virtualScroll: IonVirtualScroll;
  @ViewChild('cdk1') viewport: CdkVirtualScrollViewport;
  test: any = 'id';
  today: any;
  playMode: boolean;
  docId: any;
  specialityId: any;
  genderValue: any;
  scrollYPoint = 300;
  nextCount = [];
  hitApi = [];
  cardNum = 5;
  nextcount2: any;
  DoctorsList: any = [];
  currentDate: any;
  typeSearch: boolean = false;
  typeSearchContent: any = null;
  reviewBasedSortingOrder: any = 'DESC';
  rivewBasedSorting: boolean = false;
  clinicId: boolean;
  searchDate: any;
  pageNo: number = 1;
  count: number = 0;
  dblClikedIndex: any;
  likedPopUpStatus: boolean;
  videoOptions: any = [];
  specialityStatus: boolean = false;
  EmptyData: any;
  showProgressBar: boolean = false;
  genderStatus: boolean = true;
  Male: boolean;
  Female: boolean;
  selectedDate: any;
  Date: any = new Date();
  lattitude: any;
  longititude: any;
  dealId: any;
  searchRequest: any;
  dynClass: string;
  scrollEvent: any;
  addImg: any;
  refEvent: any;
  tymVal: any;
  prevGendVal: any;
  totalSkeleten = [];
  scrlCompleted: boolean;
  distanceBasedSorting: boolean = false;
  distanceBasedSortingOrder: any = 'ASC';
  noRecordFound: any;
  latitude: any;
  longitude: any;
  isMuteVideo: boolean = false;
  Addcheckvarible: boolean = true;
  defaultImage = 'assets/img/Vector.png';
  LocationIcon: any;

  constructor(
    public activeRoute: ActivatedRoute,
    public router: Router,
    private services: ServicesProvider,
    public modalCtrl: ModalController,
    public toastController: ToastController,
    private datePipe: DatePipe,
    public popoverCtrl: PopoverController,
    private geolocation: Geolocation,
    public addCall: AddCall,
    public common: CommonService,
    private platform: Platform,
  ) { }
  public commonAnd =  CommonService;
  scrollByPoint() {
    this.content.scrollByPoint(100, 100, 300);
  }

  scroll() {
    this.content.scrollToBottom(1000);
  }
  scrolltop() {
    this.content.scrollToTop(100);
  }

  ngOnInit() {
    this.addCall.language = localStorage.getItem('selectedLanguage')
      ? localStorage.getItem('selectedLanguage')
      : 'en';
    this.addCall.selectedLanguage = localStorage.getItem('selectedLanguage')
      ? localStorage.getItem('selectedLanguage')
      : 'en';

    if (this.addCall.selectedLanguage == 'ea') {
      let root = document.documentElement;
      root.setAttribute('style', '--direction:rtl');
    } else if (this.addCall.selectedLanguage == 'en') {
      let root = document.documentElement;
      root.setAttribute('style', '--direction:ltr');
    }

    for (let i = 1; i <= 5; i++) {
      this.totalSkeleten.push(i);
    }
    this.videoOptions = [
      {
        playMode: false,
      },
    ];
  }
  onImageErrors(event: Event): void {
    const imgElement = event.target as HTMLImageElement;
    imgElement.src = this.defaultImage;
  }
  Videobruff(el) {
    return true;
  }
  ionViewDidLeave() {
    const inViewPort = this.vdoPlayer.find((player) =>
      this.Videobruff(player.nativeElement)
    );
    if (inViewPort) {
      inViewPort.nativeElement.pause();
    }
    this.didScrollEvent('leave');
    this.isMuteVideo = false;
    this.DoctorsList = [];
    this.pageNo = 1;
    this.common.videoSound = false;
    if (this.currentPlaying) {
      this.currentPlaying.muted = true;
      this.currentPlaying?.pause();
      this.currentPlaying = null;
    }
    setTimeout(() => {
      this.didScrollEvent('leave');
      this.isMuteVideo = false;
      this.common.videoSound = false;
      if (this.currentPlaying) {
        this.currentPlaying.muted = true;
        this.currentPlaying?.pause();
        this.currentPlaying = null;
      }
    }, 500);
  }


  ionViewWillEnter() {
    // this.LocationIcon == true;
    this.Date = new Date();
    this.common.videoSound = true;
    console.log(this.common.videoSound, 'VideoSound');
    console.log('testttt', this.addCall.Date);
    console.log(
      this.activeRoute.snapshot.paramMap.get('frmAd'),
      '=================check frmpage'
    );
    let frmad = this.activeRoute.snapshot.paramMap.get('frmAd');
    if (frmad == '1') {
      this.startPage();
      console.log('check frm advertisement');
      let docid = this.activeRoute.snapshot.paramMap.get('docid');
      let clinicid = this.activeRoute.snapshot.paramMap.get('clinicid');
      let docname = this.activeRoute.snapshot.paramMap.get('docname');
      this.docAppointmentDetails(docid, clinicid, docname, '');
    }

    this.dealId = '';
    this.pageNo = 1;
    this.scrlCompleted = false;
    this.distanceBasedSortingOrder = 'ASC';
    this.tymVal = window.localStorage['DocADD'];
    let CD =
      new Date().toISOString().split('T')[0] +
      'T' +
      new Date().toTimeString().split(' ')[0];
    console.log('tymVal -> ', this.tymVal, '\nCD     -> ', CD);
    this.getAdd();
    this.today = new Date().toISOString().split('T')[0];
    this.startPage();
  }
  specialityname: any;
  frmSplHome: any = 'false';
  async startPage() {
    this.DoctorsList = [];
    this.showProgressBar = true;
    this.searchDate = new Date().toISOString().split('T')[0];
    this.typeSearch = false;
    this.typeSearchContent = null;
    this.reviewBasedSortingOrder = 'DESC';
    this.frmSplHome = this.activeRoute.snapshot.paramMap.get('frmSplHome');
    this.specialityId = this.activeRoute.snapshot.paramMap.get('id');
    this.specialityname = this.activeRoute.snapshot.paramMap.get('speciname');
    console.log(
      '===================',
      this.specialityname,
      this.specialityId,
      this.frmSplHome
    );

    let Gender = this.activeRoute.snapshot.paramMap.get('Gender');
    if (!Gender) {
      let gender = localStorage.getItem('Gender');
      if (gender == 'male' || gender == 'Male') {
        this.Male = true;
        this.genderValue = 'Male';
        this.prevGendVal = 'Male';
        this.Female = false;
      } else {
        this.Female = true;
        this.genderValue = 'Female';
        this.prevGendVal = 'Female';
        this.Male = false;
      }
    } else {
      if (Gender == 'male' || Gender == 'Male') {
        this.Male = true;
        this.genderValue = 'Male';
        this.prevGendVal = 'Male';
        this.Female = false;
      } else {
        this.Female = true;
        this.genderValue = 'Female';
        this.prevGendVal = 'Female';
        this.Male = false;
      }
    }
    if (this.specialityId != null && this.specialityId != 0) {
      this.specialityStatus = true;
    }
    // if (this.platform.is("ios")) {
      await this.geolocation
        .getCurrentPosition({
          enableHighAccuracy: true,
          timeout: 5000,
        })
        .then(
          (resp) => {
            this.LocationIcon = true;
            this.lattitude = resp.coords.latitude;
            this.longititude = resp.coords.longitude;
            this.getDocList(7);
          },
          (err) => {
            this.LocationIcon = false;
            this.lattitude = 29.62107798734671;
            this.longititude = 47.587719496877924;
            this.getDocList(8);
          }
        );
    // } else {
    //   this.getDocList(7);
    // }
  }

  doRefresh(event) {
    this.refEvent = event;
    this.pageNo = 1;
    this.showProgressBar = false;
    this.DoctorsList = [];
    this.getDocList(1);
  }
  loadData(event: any) {
    this.scrollEvent = event;
    this.pageNo += 1;
    this.getDocList(1);
  }
  async openDatePicker() {
    console.log(this.Date, 'check date check');

    const datePickerModal = await this.modalCtrl.create({
      component: DatePikerPage,
      cssClass: 'datePicker',
      componentProps: {
        selectedDate: this.selectedDate,
        calenderType: 'docList',
        curdate:
          new Date().toString().split(' ')[0] +
          ', ' +
          new Date().toString().split(' ')[1] +
          ' ' +
          new Date().toString().split(' ')[2],
      },
    });
    await datePickerModal.present();
    datePickerModal.onDidDismiss().then((data) => {
      if (data.data) {
        this.Date = data.data;
        this.selectedDate = data.data;
        this.searchDate =
          this.Date.getFullYear() +
          '-' +
          ('0' + (this.Date.getMonth() + 1)).slice(-2) +
          '-' +
          ('0' + this.Date.getDate()).slice(-2);
        this.pageNo = 1;
        this.showProgressBar = true;
        this.DoctorsList = [];
        this.getDocList(3);
        this.addCall.changeDateLan(this.selectedDate);
      }
    });
  }
  async offrDtils(myEvent, dealDet) {
    window.localStorage['dealDetl'] = JSON.stringify(dealDet);
    let popover = await this.popoverCtrl.create({
      component: ModpricetagPage,
      event: myEvent,
      componentProps: {
        from: 'Doctor',
      },
      translucent: true,
      cssClass: 'offrMod',
    });
    popover.onDidDismiss().then((data) => {
      console.log(data);
      const response = data;
      if (response.data) {
        let docId = response.data.doctorId;
        let clinicId = response.data.clinicId;
        this.dealId = response.data.dealId;
        let dName = response.data.docName;
        this.docAppointmentDetails(docId, clinicId, dName, '');
      }
    });
    return await popover.present();
  }
  async presentToast(msg) {
    const toast = await this.toastController.create({
      message: msg,
      duration: 2000,
      cssClass: 'toastStyle',
    });
    toast.present();
  }

  lastTapTime: number = 0;
  delay: number = 300;
  doubleClick(count, index, docId, isLiked) {
    // let _obj = this;
    // this.count += Number(count);
    // if (this.count == 1) {
    //   setTimeout(() => {
    //     _obj.count = 0;
    //   }, 300);
    // }
    // if (this.count == 2) {
    //   this.makeLikes(index, docId, 1, 2, isLiked);
    //   this.count = 0;
    //   this.dblClikedIndex = index;
    //   this.likedPopUpStatus = true;
    //   setTimeout(() => {
    //     _obj.likedPopUpStatus = false;
    //   }, 1000);
    // }

    const currentTime = new Date().getTime();
    const elapsedTime = currentTime - this.lastTapTime;
    if (elapsedTime < this.delay) {
      let _obj = this;
      this.makeLikes(index, docId, 1, 2, isLiked);
      this.count += Number(count);
      this.dblClikedIndex = index;
      this.likedPopUpStatus = true;
      setTimeout(() => {
        _obj.likedPopUpStatus = false;
      }, 1000);
    }
    this.lastTapTime = currentTime;
  }

  getFormattedDateTime(dateTime, callFor) {
    if (!dateTime) {
      return '';
    }
    let Value;
    switch (callFor) {
      case 'Time':
        if (dateTime.indexOf('T') > -1) {
          Value = dateTime.split('T')[1];
        } else if (dateTime.indexOf(' ') > -1) {
          Value = dateTime.split(' ')[1];
        } else {
          Value = dateTime;
        }
        let hourEnd = Value.indexOf(':');
        let H = +String(Value).substr(0, hourEnd);
        let h = H % 12 || 12;
        let ampm = H < 12 || H === 24 ? 'AM' : 'PM';
        let timeString = h + String(Value).substr(hourEnd, 3) + ' ' + ampm;
        return timeString;
      case 'Date':
        if (this.addCall.selectedLanguage == 'en') {
          return this.datepipeTransform(new Date(dateTime), 'dd MMM yy');
        } else {
          let dateCall = new Date(dateTime);
          let months = [
            'يناير',
            'فبراير',
            'مارس',
            'إبريل',
            'مايو',
            'يونيو',
            'يوليو',
            'أغسطس',
            'سبتمبر',
            'أكتوبر',
            'نوفمبر',
            'ديسمبر',
          ];
          let arDate =
            dateCall.getDate() +
            '-' +
            months[dateCall.getMonth()] +
            '-' +
            dateCall.getFullYear();
          return arDate;
        }
      case 'DateTime':
        return this.datepipeTransform(new Date(dateTime), 'dd MMM yyyy h:mm a');
    }
  }

  datepipeTransform(date: any, format: string): any {
    return this.datePipe.transform(date, format);
  }

  DateFormat(date) {
    return formatDate(new Date(date), 'EEE, MMM dd', 'en-US');
  }

  dateIncDec(incOrDec) {
    if (incOrDec == 'inc') {
      let date = null;
      date = new Date(this.Date);
      date.setDate(date.getDate() + 1);
      this.Date = date;
      this.searchDate =
        this.Date.getFullYear() +
        '-' +
        ('0' + (this.Date.getMonth() + 1)).slice(-2) +
        '-' +
        ('0' + this.Date.getDate()).slice(-2);
      this.pageNo = 1;
      this.showProgressBar = true;
      this.DoctorsList = [];
      this.getDocList(5);
    } else if (incOrDec == 'dec') {
      if (this.Date >= new Date()) {
        let date = null;
        date = new Date(this.Date);
        date.setDate(date.getDate() - 1);
        this.Date = date;
        this.searchDate =
          this.Date.getFullYear() +
          '-' +
          ('0' + (this.Date.getMonth() + 1)).slice(-2) +
          '-' +
          ('0' + this.Date.getDate()).slice(-2);
        this.pageNo = 1;
        this.showProgressBar = true;
        this.DoctorsList = [];
        this.getDocList(6);
      }
    }
    this.addCall.changeDateLan(this.Date);
  }

  backToSpeciality(type) {
    if (this.specialityStatus == true && this.frmSplHome == 'false') {
      this.router.navigate(['/tabs/speciality', { physiodoctorlist: 'Physio', speciality_name: 'Physio' }]);
      this.currentPlaying.muted = true;
    } else if (this.frmSplHome == 'true') {
      this.router.navigate(['/tabs/home']);
      this.currentPlaying.muted = true;
    } else {
      this.router.navigate(['/tabs/speciality', { physiodoctorlist: 'Physio', speciality_name: 'Physio' }]);
      this.currentPlaying.muted = true;
    }
    this.isMuteVideo = false;
  }

  selctDctGndr(value) {
    if (this.prevGendVal != value) {
      this.pageNo = 1;
      this.showProgressBar = true;
      this.DoctorsList = [];
      switch (value) {
        case 'Male': {
          this.Male = true;
          this.Female = false;
          if (this.Male == true) {
            this.genderStatus = true;
            this.genderValue = 'Male';
          } else {
            this.genderStatus = false;
          }
          break;
        }
        case 'Female': {
          this.Female = true;
          this.Male = false;
          if (this.Female == true) {
            this.genderStatus = true;
            this.genderValue = 'Female';
          } else {
            this.genderStatus = false;
          }
          break;
        }
      }
      this.getDocList(11);
    }
    this.prevGendVal = value;
  }

  //API Integration Events......................
  SearchIt() {
    this.pageNo = 1;
    this.DoctorsList = [];
    if (this.typeSearchContent != null) {
      this.getDocList(12);
      this.typeSearch = true;
    }
  }
  reviewSort() {
    this.pageNo = 1;
    this.DoctorsList = [];
    this.showProgressBar = true;
    if (this.reviewBasedSortingOrder == 'ASC') {
      this.reviewBasedSortingOrder = 'DESC';
    } else if (this.reviewBasedSortingOrder == 'DESC') {
      this.reviewBasedSortingOrder = 'ASC';
    }
    this.getDocList(13);
  }
  docAppointmentDetails(docId, clinicId, dName, rev) {
    window.localStorage['isRev'] = rev;
    localStorage.setItem('fromPage', 'newBooking');
    window.localStorage['docName'] = dName;
    console.log(
      docId,
      clinicId,
      this.searchDate,
      this.dealId,
      this.specialityId,
      this.genderValue,
      this.specialityname
    );

    this.router.navigate([
      '/tabs/physio-doc-appointment',
      {
        doctorId: docId,
        clinicId: clinicId,
        searchDate: this.searchDate,
        serviceTypeId: this.dealId,
        splid: this.specialityId,
        Gender: this.genderValue,
        splname: this.specialityname,
      },
    ]);
    setTimeout(() => {
      this.isMuteVideo = false;
      this.common.videoSound = false;
      this.currentPlaying.muted = true;
      this.currentPlaying?.pause();
      this.currentPlaying = null;
    }, 2000);
  }

  //API Integration.............
  async getDocList(from) {
    console.log('FROM -----> ', from);
    if (this.pageNo == 1) {
      this.DoctorsList = [];
      this.content.scrollToTop();
    }

    this.EmptyData = false;
    if (this.searchRequest && from != 2) {
      this.searchRequest.unsubscribe();
    }
    if (this.typeSearchContent == null) {
      this.typeSearchContent = '';
    }
    if (!this.lattitude) {
      this.lattitude = 0;
    }
    if (!this.longititude) {
      this.longititude = 0;
    }
    let getDate = new Date();
    this.currentDate =
      getDate.getFullYear() +
      '-' +
      ('0' + (getDate.getMonth() + 1)).slice(-2) +
      '-' +
      ('0' + getDate.getDate()).slice(-2);
    // if (this.platform.is("ios")) {
    //  await this.geolocation
    //     .getCurrentPosition({
    //       enableHighAccuracy: true,
    //       timeout: 5000,
    //     })
    //     .then((resp) => {
    //       this.latitude = resp.coords.latitude;
    //       this.longitude = resp.coords.longitude;
    //       let requestdata = JSON.stringify({
    //         patientId: localStorage.getItem('patient_id'),
    //         doctorGenderChecking: false,
    //         doctorGender: this.genderValue,
    //         currentDate: this.currentDate,
    //         searchDate: this.searchDate,
    //         day: false,
    //         night: false,
    //         lat: this.latitude,
    //         long: this.longitude,
    //         costBasedSorting: false,
    //         reviewBasedSorting: this.rivewBasedSorting, //this.reviewSorting
    //         reviewBasedSortingOrder: this.reviewBasedSortingOrder,
    //         costBasedSortingOrder: 'DESC',
    //         speciality: this.specialityStatus,
    //         specialityId: Number(this.specialityId),
    //         advanceFilter: false,
    //         advanceFilterCost: '',
    //         advanceFilterOffers: '',
    //         advanceFilterDistance: '',
    //         limit: 20, //count
    //         pageno: this.pageNo, //this.pageNo
    //         typeSearch: this.typeSearch,
    //         typeSearchContent: this.typeSearchContent,
    //         current_time: new Date().toTimeString().split(' ')[0],
    //         distanceBasedSorting: this.distanceBasedSorting,
    //         distanceBasedSortingOrder: this.distanceBasedSortingOrder,
    //       });
    //       this.searchRequest = this.services
    //         .postRequest('patientPhysioDoctorSearch', requestdata)
    //         .subscribe((res) => {
    //           console.log('patient doctor search', res);
    //           if (res.status == 1) {
    //             for (let item of res.data[0].details) {
    //               this.DoctorsList.push(item);
    //             }
    //           }
    //           this.noRecordFound = res.data[0].details.length;

    //           if (this.common.videoSound) {
    //             let _obj = this;
    //             const interval = setInterval(() => {
    //               console.log('Trigger from API');
    //               console.log('No Video');
    //               _obj.currentPlaying = null;
    //               if (_obj.vdoPlayer) {
    //                 console.log('Video');
    //                 this.didScrollEvent('leave');
    //                 clearInterval(interval);
    //               }
    //             }, 0);
    //           } else {
    //             console.log('123456789-SoundOFF');
    //           }

    //           this.EmptyData = this.DoctorsList.length <= 0 ? true : false;
    //           this.showProgressBar = false;
    //         });
    //       console.log(this.latitude, this.longitude);
    //       console.log(resp.coords.longitude, resp.coords.latitude);
    //     },(err)=>{
    //       this.LocationIcon = false;
    //       this.latitude = 29.62107798734671;
    //       this.longitude = 47.587719496877924;
    //       let requestdata = JSON.stringify({
    //         patientId: localStorage.getItem('patient_id'),
    //         doctorGenderChecking: false,
    //         doctorGender: this.genderValue,
    //         currentDate: this.currentDate,
    //         searchDate: this.searchDate,
    //         day: false,
    //         night: false,
    //         lat: this.latitude,
    //         long: this.longitude,
    //         costBasedSorting: false,
    //         reviewBasedSorting: this.rivewBasedSorting, //this.reviewSorting
    //         reviewBasedSortingOrder: this.reviewBasedSortingOrder,
    //         costBasedSortingOrder: 'DESC',
    //         speciality: this.specialityStatus,
    //         specialityId: Number(this.specialityId),
    //         advanceFilter: false,
    //         advanceFilterCost: '',
    //         advanceFilterOffers: '',
    //         advanceFilterDistance: '',
    //         limit: 20, //count
    //         pageno: this.pageNo, //this.pageNo
    //         typeSearch: this.typeSearch,
    //         typeSearchContent: this.typeSearchContent,
    //         current_time: new Date().toTimeString().split(' ')[0],
    //         distanceBasedSorting: this.distanceBasedSorting,
    //         distanceBasedSortingOrder: this.distanceBasedSortingOrder,
    //       });
    //       this.searchRequest = this.services
    //         .postRequest('patientPhysioDoctorSearch', requestdata)
    //         .subscribe((res) => {
    //           console.log('patient doctor search', res);
    //           if (res.status == 1) {
    //             for (let item of res.data[0].details) {
    //               this.DoctorsList.push(item);
    //             }
    //           }
    //           this.noRecordFound = res.data[0].details.length;

    //           if (this.common.videoSound) {
    //             let _obj = this;
    //             const interval = setInterval(() => {
    //               console.log('Trigger from API');
    //               console.log('No Video');
    //               _obj.currentPlaying = null;
    //               if (_obj.vdoPlayer) {
    //                 console.log('Video');
    //                 this.didScrollEvent('leave');
    //                 clearInterval(interval);
    //               }
    //             }, 0);
    //           } else {
    //             console.log('123456789-SoundOFF');
    //           }

    //           this.EmptyData = this.DoctorsList.length <= 0 ? true : false;
    //           this.showProgressBar = false;
    //         });
    //       console.log(this.latitude, this.longitude);
    //     })
    // }else {


      let requestdata = JSON.stringify({
        patientId: localStorage.getItem('patient_id'),
        doctorGenderChecking: false,
        doctorGender: this.genderValue,
        currentDate: this.currentDate,
        searchDate: this.searchDate,
        day: false,
        night: false,
        // lat: this.commonAnd.androidLatitude ?? 29.62107798734671,
        // long: this.commonAnd.androidLongitude ?? 47.587719496877924,
        lat: this.lattitude,
        long: this.longititude,
        costBasedSorting: false,
        reviewBasedSorting: this.rivewBasedSorting, //this.reviewSorting
        reviewBasedSortingOrder: this.reviewBasedSortingOrder,
        costBasedSortingOrder: 'DESC',
        speciality: this.specialityStatus,
        specialityId: Number(this.specialityId),
        advanceFilter: false,
        advanceFilterCost: '',
        advanceFilterOffers: '',
        advanceFilterDistance: '',
        limit: 20, //count
        pageno: this.pageNo, //this.pageNo
        typeSearch: this.typeSearch,
        typeSearchContent: this.typeSearchContent,
        current_time: new Date().toTimeString().split(' ')[0],
        distanceBasedSorting: this.distanceBasedSorting,
        distanceBasedSortingOrder: this.distanceBasedSortingOrder,
      });
      this.searchRequest = this.services
        .postRequest('patientPhysioDoctorSearch', requestdata)
        .subscribe((res) => {
          console.log('patient doctor search', res);
          if (res.status == 1) {
            for (let item of res.data[0].details) {
              this.DoctorsList.push(item);
            }
          }
          this.noRecordFound = res.data[0].details.length;

          if (this.common.videoSound) {
            let _obj = this;
            const interval = setInterval(() => {
              console.log('Trigger from API');
              console.log('No Video');
              _obj.currentPlaying = null;
              if (_obj.vdoPlayer) {
                console.log('Video');
                this.didScrollEvent('leave');
                clearInterval(interval);
              }
            }, 0);
          } else {
            console.log('123456789-SoundOFF');
          }
          this.EmptyData = this.DoctorsList.length <= 0 ? true : false;
          this.showProgressBar = false;
        });
    }
  // }

  makeLikes(i, docId, isLyk, from, isLiked) {
    try {
      let data = JSON.stringify({
        vendor_id: docId,
        like: isLyk,
        user_id: localStorage.getItem('patient_id'),
        module_name: 'Physio',
        isLiked: isLiked
      });
      const UpdateVendorLikes = this.services
        .postRequestPhysioDoc('UpdateVendorLikes', data)
        .subscribe(
          (res) => {
            debugger
            console.log(res);
            if (this.DoctorsList[i].isLiked != 'true') {
              this.DoctorsList[i].likes_count =
                Number(this.DoctorsList[i].likes_count) + 1;
            }
            this.DoctorsList[i].isLiked = 'true';
          },
          (err) => {
            console.log(err);
          }
        );
    } catch (err) {
      console.log(err);
    }
  }

  makeLike(i, docId, isLyk, from, isLiked) {
    try {
      if (this.DoctorsList[i].isLiked == null) {
        this.DoctorsList[i].isLiked = 'true';
        this.DoctorsList[i].likes_count =
          Number(this.DoctorsList[i].likes_count) + 1;
      }
      if (from == 2) {
        if (this.DoctorsList[i].isLiked == 'false') {
          this.DoctorsList[i].isLiked = 'true';
          this.DoctorsList[i].likes_count =
            Number(this.DoctorsList[i].likes_count) + 1;
        }
      } else if (from == 1) {
        if (this.DoctorsList[i].isLiked == 'false') {
          this.DoctorsList[i].isLiked = 'true';
          this.DoctorsList[i].likes_count =
            Number(this.DoctorsList[i].likes_count) + 1;
        } else if (this.DoctorsList[i].isLiked == 'true') {
          this.DoctorsList[i].isLiked = 'false';
          this.DoctorsList[i].likes_count =
            Number(this.DoctorsList[i].likes_count) - 1;
        }
      }
      let data = JSON.stringify({
        vendor_id: docId,
        like: isLyk,
        user_id: localStorage.getItem('patient_id'),
        module_name: 'Physio',
        isLiked: isLiked
      });
      this.services.postRequestPhysioDoc('UpdateVendorLikes', data).subscribe(
        (res) => {
          console.log(res);
        },
        (err) => {
          console.log(err);
        }
      );
    } catch (err) {
      console.log(err);
    }
  }

  async openAdvr() {
    window.localStorage['addType'] = 2;
    let popover = await this.modalCtrl.create({
      component: AdvertisementPage,
      componentProps: {
        addImg: this.addImg,
      },
      cssClass: this.dynClass,
    });
    popover.onDidDismiss().then((data) => {
      this.Addcheckvarible = false;
      if (!this.Addcheckvarible) {
        this.didScrollEvent('leave');
      }
    });
    return await popover.present();
  }

  getAdd() {
    try {
      let min = new Date(new Date().setTime(new Date().getTime() + 3600000));
      let CT =
        min.toISOString().split('T')[0] +
        'T' +
        min.toTimeString().split(' ')[0];
      this.tymVal = CT;
      window.localStorage['DocADD'] = CT;

      let today = new Date().toISOString().split('T')[0];
      let data = JSON.stringify({
        vendor_type_id: 12,
        current_date: today,
      });
      this.services
        .postRequestGndrl('admin/get_current_advertisement', data)
        .subscribe(
          (res) => {
            if (res.data.length > 0) {
              this.Addcheckvarible = true;
              this.addImg = res.data[0].ad_path_name;
              if (res.data[0].ad_size == '2') {
                this.dynClass = 'advertisement1';
              } else if (res.data[0].ad_size == '1') {
                this.dynClass = 'advertisement2';
              }
              this.openAdvr();
            } else {
              this.Addcheckvarible = false;
              setTimeout(() => {
                this.didScrollEvent('leave');
              }, 1000);
            }      
          },
          (err) => {
            console.log(err);
          }
        );
    } catch (err) {
      console.log(err);
    }
  }

  async playMedia() {
    try {
      await this.currentPlaying?.play();
    } catch (err) {
      await this.currentPlaying?.pause();
      console.log('Paused - ', err);
      this.didScrollEvent('leave');
    }
  }

  isElementInViewPort(el) {
    const rect = el.getBoundingClientRect();
    const top = Math.round(rect.top);
    const left = Math.round(rect.left);
    const bottom = Math.round(rect.bottom);
    const right = Math.round(rect.right);

    return (
      top >= 0 &&
      left >= 0 &&
      bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
      right <= (window.innerWidth || document.documentElement.clientWidth)
    );
  }

  pausePlay(id, mid) {
    const uniqueVideoId = `VideoLab${id}${mid}`;
    if (this.currentPlaying?.id !== uniqueVideoId) {
      if (this.currentPlaying) this.currentPlaying.pause();
      this.currentPlaying = document.getElementById(uniqueVideoId);
    }
    if (this.currentPlaying) {
      this.currentPlaying.paused
        ? this.currentPlaying.play()
        : this.currentPlaying.pause();
    }
  }

  didScrollEvent(event) {
    try {
      if (this.Addcheckvarible) return;
      const inViewPort = this.vdoPlayer.find((player) =>
        this.isElementInViewPort(player.nativeElement)
      );
      if (inViewPort && this.currentPlaying !== inViewPort.nativeElement) {
        if (this.currentPlaying) this.currentPlaying.pause();
        this.currentPlaying = inViewPort.nativeElement;
        this.currentPlaying.paused
          ? this.currentPlaying.play()
          : this.currentPlaying.pause();
      } else if (!inViewPort && this.currentPlaying) {
        this.currentPlaying.pause();
        this.currentPlaying = null;
      }
    } catch (err) {
      console.error(err);
    }
  }

  async opensortpage() {
    const alert = await this.modalCtrl.create({
      component: RatingSortpagePage,
      showBackdrop: true,
      cssClass: 'rating_sort_page_doctor',
      backdropDismiss: false,
      componentProps: {
        frm: 'Doctor',
      },
    });
    alert.onDidDismiss().then((data) => {
      console.log(data);
      console.log(data.data.orderWise, 'and', data.data.orderby);
      if (data.data.orderWise != null) {
        this.pageNo = 1;
        this.DoctorsList = [];
        if (data.data.orderby == 'Rating') {
          this.showProgressBar = true;
          this.distanceBasedSorting = false;
          this.rivewBasedSorting = true;
          this.reviewBasedSortingOrder = data.data.orderWise;
          this.getDocList(13000);
        } else if (data.data.orderby == 'Distance') {
          this.rivewBasedSorting = false;
          this.showProgressBar = true;
          this.distanceBasedSorting = true;
          this.distanceBasedSortingOrder = data.data.orderWise;
          this.getDocList(131000);
        }
      }
    });

    await alert.present();
  }

  async OpenMapMethod(clinicname: any, clinic_address: any, clinic_lat_long: any) {
    const modal = await this.modalCtrl.create({
      component: SuccessPage,
      cssClass: 'mapmodel',
      componentProps: {
        typeValue: 33,
        clinicname: clinicname,
        clinic_address: clinic_address,
        clinic_lat_long: clinic_lat_long,
      }
    });
    modal.onDidDismiss()
    .then((data) => {
      if (data.data == "Map_Not_Show") {
         this.ionViewWillEnter();
      }
    });
    return await modal.present();
  }
}
